export default function snakeCaseToCamelCase(value: string) {
  return value.replace(/(_[a-z])/gi, ($1) => $1.toUpperCase().replace("_", ""));
}
